import {
  TaxCode,
  KiwisaverStatus,
  ContributionOption,
  KiwisaverContributionRate,
  Country,
} from '$constants'
import { Nullable } from '$models'
import {
  formatBankAccountNumber,
  formatIRD,
  transformStringToNumberProperty,
} from '$utils'
import {
  BaseStaffMember,
  StaffMember,
  transformBaseStaffMemberOnGet,
  transformBaseStaffMemberOnSave,
} from './staffMember'

export interface StaffMemberNz extends BaseStaffMember {
  irdNumber?: Nullable<string>
  taxCode?: Nullable<TaxCode>
  employerKiwisaverContributionTaxRate?: Nullable<KiwisaverContributionRate>
  kiwisaverStatus?: Nullable<KiwisaverStatus>
  contributionOption?: Nullable<ContributionOption>
  employeeContribution?: Nullable<number>
  employerContribution?: Nullable<number>
  employerContributionThroughSalarySacrifice?: Nullable<number>
}

// Function to apply transformations to StaffMemberNz object on get
export const transformStaffMemberNzOnGet = (
  staffMember: StaffMember
): StaffMemberNz => {
  const transformedStaffMember: StaffMemberNz =
    transformBaseStaffMemberOnGet(staffMember)

  transformedStaffMember.bankAccountNumber = formatBankAccountNumber(
    transformedStaffMember.bankAccountNumber,
    Country.NewZealand
  )

  transformedStaffMember.irdNumber = formatIRD(transformedStaffMember.irdNumber)

  return transformedStaffMember
}

// Function to apply transformations to StaffMemberNz object on get
export const transformStaffMemberNzOnSave = (
  staffMember: StaffMember
): object => {
  const staffMemberNz: StaffMemberNz = staffMember as StaffMemberNz
  staffMemberNz.irdNumber = staffMemberNz.irdNumber?.replaceAll('-', '')
  staffMemberNz.employerContributionThroughSalarySacrifice =
    transformStringToNumberProperty(
      `${staffMemberNz.employerContributionThroughSalarySacrifice}`
    )

  const transformedStaffMember = transformBaseStaffMemberOnSave(staffMemberNz)

  return transformedStaffMember
}
